export const SCENARIOS = {
  UNLINK_TWO: 'unlink-two',
  APPROVE_TWO: 'approve-two',
  APPROVE_MANY: 'approve-many',
  REMOVE_INDIVIDUAL: 'remove-individual',
  UNLINKED: 'unlinked',
} as const;

export type Scenario = (typeof SCENARIOS)[keyof typeof SCENARIOS];
